import { render, staticRenderFns } from "./preview-video.vue?vue&type=template&id=74961931&scoped=true&"
import script from "./preview-video.vue?vue&type=script&lang=js&"
export * from "./preview-video.vue?vue&type=script&lang=js&"
import style0 from "./preview-video.vue?vue&type=style&index=0&id=74961931&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74961931",
  null
  
)

export default component.exports